import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import { FindPipeModule } from '@main-client/src/app/pipes/find-pipe/find-pipe.module';
import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';

import { GroupSegmentNodePickerComponent } from './group-segment-node-picker.component';

@NgModule({
  imports: [
    CommonModule,
    FindPipeModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    TranslationLookupModule,
  ],
  declarations: [GroupSegmentNodePickerComponent],
  exports: [GroupSegmentNodePickerComponent],
})
export class GroupSegmentNodePickerModule {}
